import { createContext } from "react";

export const UsersReportContext = createContext();